import React, { useEffect, useState } from 'react';
import Header from "../../../../components/Headers/BasicHeader";
import '../Index.css'
import Paginations from '../../../../components/Pagination/BasicPagination';
import { useNavigate } from "react-router-dom";
import { setDataOnGrid, applySearch } from '../../../../utils/views/pages/Dynamics'

import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Table,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Button,
    Spinner
} from "reactstrap";
import { getDevices, deleteDevice } from "../../../../network/ApiAxios";
import ConfirmModal from 'components/Modals/ConfirmModal';
import  secureLocalStorage  from  "react-secure-storage";

const Devices = () => {

    const [devices, setDevices] = useState([]);
    const [devicesBackup, setDevicesBackup] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalResult, setModalResult] = useState(false)
    const [modalOperation, setModalOperation] = useState()
    const [reloadData, setReloadData] = useState(false)
    const [deletedId, setDeletedId] = useState()
    const [bindingId, setBindingId] = useState()
    const [itemsPerPage, setItemsPerPage] = useState(process.env.REACT_APP_PAGE_ITEMS)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKey, setSearchKey] = useState('')
    const [foundRegisters, setFoundRegisters] = useState()
    const [loadingId, setLoadingId] = useState('')
    const [isLoading, setisLoading] = useState(false)

    const [sortField, setSortField] = useState('')
    const [sortDirection, setSortDirection] = useState('asc')

    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const navigate = useNavigate();
    const searchFields = ['uniqueId', 'model', 'brand']
    const [searchAction, setSearchAction] = useState(false)

    /**
     * Carregamento dos dados principais para alimentar o grid 
     * Alimenta os objetos que permitirão realizar buscas e filtragens
     * dinamicamente
     */
    useEffect(() => {
        const runAsync = async () => {
            setisLoading(true);

            let params = { filter: { account: user.account } }

            const response = await getDevices(params);
            const { data } = response;
            
            if (data.success) {
                setFoundRegisters(data.devices?.length)

                const sortedData = applySorting(data.devices);

                setDataOnGrid(sortedData, setDevices, currentPage, itemsPerPage);
                setDevicesBackup(data.devices);
                setReloadData(false);
                setLoadingId('');
                setisLoading(false);
            }
        }
        runAsync();
    }, [reloadData]);

    /**
     * Trata ações realizadas nesta pagina, como a deleção de objetos
     * e a vinculação de devices com licenças ativas da conta para 
     * uso de aplicativos
     */
    useEffect(() => {
        if (modalResult && modalOperation=='delete') {
            const runAsync = async () => {

                setLoadingId(deletedId);
                const response = await deleteDevice(deletedId);
                const { data } = response;

                if (data.success) {             
                    setReloadData(true); 
                    setModalResult(false);
                    setDeletedId('');                   
                }
            }
            runAsync();
        } else if (modalResult && modalOperation=='bind') {
            alert("binding something...")
            setReloadData(true); 
            setModalResult(false);
            setBindingId('')
        }
    }, [modalResult])


    /**
     * Gatilho que captura situações onde devemos realizar busca de dados de acordo com 
     * filtro e reordenar os dados para mostrar no grid
     */
    useEffect(() => {
        if(!searchAction){ 
            applySearch(searchKey, searchFields, setDevices, devicesBackup, setFoundRegisters, currentPage, itemsPerPage, true);                    
            const sortedData = applySorting(devices);
            setDataOnGrid(sortedData, setDevices, currentPage, itemsPerPage);
        } else {
            setSearchAction(false)
        }

    }, [sortField, sortDirection, searchKey, currentPage, itemsPerPage])

    const sortData = (data, field, direction) => {
        if(!field) return data;

        const getNestedValue = (obj, path) => {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }


        return [...data].sort((a,b) => {
            let aValue = getNestedValue(a, field) || '';
            let bValue = getNestedValue(b, field) || '';
            if (typeof aValue === 'string') aValue = aValue.toLowerCase();
            if (typeof bValue === 'string') bValue = bValue.toLowerCase();

            if(direction === 'asc'){
                //Para ordem crescrente
                return aValue > bValue ? 1 : -1;
            } else {
                //Para ordem decrescente
                return aValue < bValue ? 1 : -1;
            }
        })

    }

    const applySorting = (data) => {
        if(!sortField) return data;
        return sortData(data, sortField, sortDirection);
    }

    let handleSort = (field) => {
        if(sortField === field){
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else{
            setSortField(field);
            setSortDirection('asc');
        }
        setCurrentPage(1);
    } 

    let handleDelete = (id) => {
        setModalOperation("delete")
        setModalTitle("Device Deletion")
        setModalMessage("Are you sure you want to delete this device?")
        setShowModal(true)
        setDeletedId(id)
    }

    let handleSearch = (e) => {
        setSearchAction(true)
        setSearchKey(e.target.value)
        applySearch(e.target.value, searchFields, setDevices, devicesBackup, setFoundRegisters, currentPage, itemsPerPage, true);
    }

    let handleBind = (id) => {
        setModalOperation("bind")
        setModalTitle("Link Device to License")
        setModalMessage("Are you sure you want to bind this device to a  Listen First usage license?")
        setShowModal(true)
        setBindingId(id)
    }

    return (
        <>
            <Header></Header>

            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 pb-3 pt-3 pt-md-3">

                                <Row id="headerOptions" className=''>

                                    <Col lg="8" md="8">
                                        <Form className="navbar-search-light form-inline mr-3 d-none d-md-flex  w-100   ">
                                            <FormGroup className="mb-0 w-100 ">
                                                <InputGroup id="search-input" className="input-group-alternative w-100 ">

                                                    <InputGroupAddon addonType="prepend" className='w-100'>
                                                        <InputGroupText >
                                                            <i className="fas fa-search" />
                                                        </InputGroupText>
                                                        <Input value={searchKey} onChange={handleSearch} className='w-100' placeholder="Search" type="text" />
                                                    </InputGroupAddon>

                                                </InputGroup>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                    <Col id='addButton' lg="4" md="4">
                                        <Button onClick={() => navigate('/admin/device/create')}
                                            className="btn-icon btn-3" color="primary" type="button">

                                            <span className="btn-inner--text">Create a device</span>

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-fat-add" />
                                            </span>

                                        </Button>
                                    </Col>
                                        
                                    
                                </Row>
                            </CardHeader>

                            {isLoading && !loadingId ? (
                                <div className="text-center p-5">
                                    <Spinner size="lg"/>
                                </div>

                            ) : (

                                <Table className="align-items-center table-flush" responsive>
                                    <thead >
                                        <tr>
                                            <th scope="col" 
                                                onClick={() => handleSort('uniqueId')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'uniqueId' ? 'table-header-sorted' : ''}
                                            >
                                                Unique ID
                    
                                                    <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />
                                                
                                    
                                            </th>
                                            <th scope="col" 
                                                onClick={() => handleSort('model')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'model' ? 'table-header-sorted' : ''}
                                            >
                                                Model
                    
                                                    <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />
                                                
                                    
                                            </th>        
                                            <th scope="col" 
                                                onClick={() => handleSort('brand')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'brand' ? 'table-header-sorted' : ''}
                                            >
                                                Brand
                    
                                                    <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />
                                                
                                    
                                            </th>        
                                            <th scope="col" className='text-right'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {devices.map(device => (
                                            <tr key={device.uniqueId}>
                                                <td scope="row">  {device.uniqueId} </td>
                                                <td>{device.model}</td>
                                                <td>{device.brand}</td>
                                                <td className='text-right'>
                                                    {function () {
                                                        if (!device.isBound)
                                                            return (

                                                                <Button className="btn-icon action" color="info" type="button"
                                                                    onClick={() => handleBind(device._id)}
                                                                    disabled={loadingId === devices._id}
                                                                >

                                                                    <span className="btn-inner--icon">
                                                                        <img
                                                                            id="bind-button"
                                                                            alt="bind"
                                                                            src={require("assets/img/icons/common/bind.svg").default}
                                                                        />
                                                                    </span>


                                                                </Button>
                                                            )
                                                    }()
                                                    }

                                                    <Button className="btn-icon action" color="success" type="button"
                                                        onClick={() => navigate('/admin/device/view/' + device._id)}
                                                        disabled={loadingId === devices._id}
                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img
                                                                id="view-button"
                                                                alt="view"
                                                                src={require("assets/img/icons/common/eye-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>

                                                    <Button className="btn-icon action" color="primary" type="button"
                                                        onClick={() => navigate('/admin/device/edit/' + device._id)}
                                                        disabled={loadingId === devices._id}
                                                    >
                                                            

                                                        <span className="btn-inner--icon">
                                                            <img

                                                                alt="edit"
                                                                src={require("assets/img/icons/common/edit-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>
                                                    <Button className="btn-icon action" color="warning" type="button"
                                                        onClick={() => handleDelete(device._id)} 
                                                        disabled={loadingId === devices._id}
                                                    
                                                    >

                                                        {loadingId === device._id ? (
                                                            <Spinner size="sm" className="me-2 mx-1" />
                                                        
                                                        ) : (
                                                            <>
                                                            <span className="btn-inner--icon">
                                                                <img
                                                                    id="delete-button"
                                                                    alt="delete"
                                                                    src={require("assets/img/icons/common/delete-button.svg").default}
                                                                />
                                                            </span>
                                                            </>
                                                        )}

                                                    </Button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            
                            )}
                        </Card>
                    </div>
                </Row>

                <Row className='pt-md-3'>
                    <Col>
                        <span className="h5 itens-quantity">
                            {devicesBackup?.length} devices
                        </span>
                    </Col>
                    <Col>
                        <Paginations
                            itemsPerPage={itemsPerPage}
                            totalItems={foundRegisters}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                        />

                    </Col>
                </Row>

            </Container>

            <ConfirmModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                setModalResult={setModalResult} />
        </>
    );
}

export default Devices;
